import React, {useState} from "react";
import {WhatsAppOutlined, CloseOutlined, CopyOutlined, CheckOutlined} from "@ant-design/icons";
import {FixedButton, FixedButtonWrapper} from "./WhatsappSupportButton.style";

const WHATSAPP_NUMBER = "908502423093";
const PHONE_DISPLAY = "+90 0850 242 30 93";

export const WhatsappSupportButton = () => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(PHONE_DISPLAY).then(() => {
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                });
            } else {
                const el = document.createElement("textarea");
                el.value = PHONE_DISPLAY;
                el.style.position = "fixed";
                el.style.opacity = "0";
                document.body.appendChild(el);
                el.focus();
                el.select();
                document.execCommand("copy");
                document.body.removeChild(el);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            }
        } catch (e) {
            console.error("Kopyalama başarısız:", e);
        }
    };

    const handleWhatsapp = () => {
        window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
    };

    return (
        <>
            <FixedButtonWrapper onClick={() => setOpen(true)}>
                <FixedButton shape="circle" icon={<WhatsAppOutlined style={{fontSize: 25}} />} />
            </FixedButtonWrapper>

            {open && (
                <div style={styles.overlay} onClick={() => setOpen(false)}>
                    <div style={styles.modal} onClick={e => e.stopPropagation()}>
                        {/* Header */}
                        <div style={styles.header}>
                            <div>
                                <div style={styles.title}> Vigo+ İşletme Destek Hattı</div>
                                <div style={styles.subtitle}>
                                    💬 09:00-01:00 saatleri arasında sizlere destek olmaktan
                                    mutluluk duyarız.
                                </div>
                            </div>
                            <button style={styles.closeBtn} onClick={() => setOpen(false)}>
                                <CloseOutlined style={{fontSize: 16, color: "#1a1a1a"}} />
                            </button>
                        </div>

                        {/* Body */}
                        <div style={styles.body}>
                            {/* Phone Number  */}
                            <div style={styles.phoneReference}>
                                <div style={styles.phoneLeft}>
                                    <span style={styles.phoneLabel}>Destek Hattı Numarası</span>
                                    <span style={styles.phoneNumber}>{PHONE_DISPLAY}</span>
                                </div>
                                <button
                                    style={{
                                        ...styles.copyBtn,
                                        backgroundColor: copied ? "#e8f5e9" : "#f5f5f5"
                                    }}
                                    onClick={handleCopy}
                                    title={copied ? "Kopyalandı!" : "Kopyala"}
                                >
                                    {copied ? (
                                        <CheckOutlined style={{fontSize: 16, color: "#4caf50"}} />
                                    ) : (
                                        <CopyOutlined style={{fontSize: 16, color: "#888"}} />
                                    )}
                                </button>
                            </div>
                            <br />
                            {/* Primary CTA */}
                            <button style={styles.whatsappBtn} onClick={handleWhatsapp}>
                                <WhatsAppOutlined style={{fontSize: 20}} />
                                <span>WhatsApp ile Yaz</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        paddingBottom: 96,
        paddingRight: 20,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        backdropFilter: "blur(2px)"
    },
    modal: {
        width: 340,
        borderRadius: 20,
        overflow: "hidden",
        boxShadow: "0 12px 48px rgba(0, 0, 0, 0.3)",
        animation: "slideUp 0.25s ease-out"
    },
    header: {
        backgroundColor: "#AEF001",
        padding: "20px 20px 18px 20px",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 12
    },
    title: {
        fontWeight: 700,
        fontSize: 16,
        color: "#1a1a1a",
        lineHeight: 1.3,
        marginBottom: 4
    },
    subtitle: {
        fontSize: 13,
        color: "#1a1a1a",
        opacity: 0.75,
        lineHeight: 1.4
    },
    closeBtn: {
        background: "rgba(0, 0, 0, 0.08)",
        border: "none",
        borderRadius: "50%",
        width: 32,
        height: 32,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        flexShrink: 0,
        transition: "all 0.2s ease"
    },
    body: {
        backgroundColor: "#ffffff",
        padding: "20px"
    },
    whatsappBtn: {
        width: "100%",
        backgroundColor: "#AEF001",
        border: "none",
        borderRadius: 12,
        padding: "16px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        fontSize: 16,
        fontWeight: 700,
        color: "#1a1a1a",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(191, 255, 0, 0.25)",
        transition: "all 0.2s ease"
    },
    phoneReference: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 16px",
        backgroundColor: "#f8f8f8",
        borderRadius: 10,
        gap: 12
    },
    phoneLeft: {
        display: "flex",
        flexDirection: "column",
        gap: 4
    },
    phoneLabel: {
        fontSize: 11,
        fontWeight: 600,
        color: "#888",
        textTransform: "uppercase",
        letterSpacing: 0.5
    },
    phoneNumber: {
        fontSize: 15,
        fontWeight: 600,
        color: "#1a1a1a",
        letterSpacing: 0.3
    },
    copyBtn: {
        backgroundColor: "#f5f5f5",
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        width: 36,
        height: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        flexShrink: 0,
        transition: "all 0.2s ease"
    }
};
